import { render, staticRenderFns } from "./SalInvoiceFunction.vue?vue&type=template&id=bf9f2e94&"
import script from "./SalInvoiceFunction.vue?vue&type=script&lang=js&"
export * from "./SalInvoiceFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports